// Bump AUDIO_VERSION to bypass stale CDN copies after audio format changes.
const AUDIO_VERSION = 'm4a1';

export const withAudioVersion = (url) =>
  url ? `${url}${url.includes('?') ? '&' : '?'}v=${AUDIO_VERSION}` : url;
